import AccessoryCommon from "./accessoryCommon";
import {createParentPositions} from "../../constants";
import {Shower} from "../../parts/shower";
import {ShowerTubCombo} from "../../../../bvSceneComponent/core/parts/showerTubCombo";

export default class Seats extends AccessoryCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'shower_seats';
    this.partName = 'Seats';
    this.dbName = 'Seats';
    this.translateId = "visualizer.bathroom.accessories.shower_seats";
    this.visible = true;
    this.canBeDisabled = true;
    this.conflictingPositions = ["valve_trim"];
    if (isChild) {
      createParentPositions(this);
    }
  }

  disabledClick() {
    Object.keys(this.layerPositions).forEach(position => {
      if (this.layerPositions[position] && this.layerPositions[position].metaData["layerPosition"]) {
        this.checkRelatedFeatureGroupPositions(this.layerPositions[position].metaData["layerPosition"]);
      }
    })
  }

  handleClick(...props) {
    super.handleClick(...props);
    const parent = this.getParent();
    const showerComboParent = parent.getParent().layout.parts[ShowerTubCombo.id]
    if (showerComboParent.showerTubComboIsActive) {
      showerComboParent.showerTubComboIsActive = false;
    }
    parent.checkRelatedFeatureGroupPositions(this.metaData["layerPosition"], this);
  }

  setLayers(layout) {
    const showerParent = this.getParent().layout.parts[Shower.id];
    if (showerParent && showerParent.showerTubComboIsActive()) { //  shower tub combo - remove
      super.hideLayers();
      return;
    }

    return super.setLayers(layout);
  }
  //
  // setZIndex(zIndexes) {
  //   if (zIndexes) {
  //     Object.keys(this.layerPositions).forEach((key, keyIndex) => {
  //       if (this.layerPositions[key]) {
  //         this.layerPositions[key].layer.zIndex = zIndexes.Accessories.Seats + keyIndex*10;
  //       }
  //     })
  //   }
  // }

}
